import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const enqueueWorkItemCallable = httpsCallable<{
  type: string;
  title: string;
  clientId?: string;
  matterId?: string;
  linkedAlertId?: string;
  linkedTaskId?: string;
  priority?: string;
  dueAt?: string;
}, { success: true; queueItemId: string }>(functions, "enqueueWorkItem");

export const createOperationalTaskCallable = httpsCallable<{
  title: string;
  status?: "OPEN" | "IN_PROGRESS" | "BLOCKED" | "COMPLETED";
  priority?: string;
  clientId?: string;
  matterId?: string;
  linkedAlertId?: string;
  linkedQueueItemId?: string;
  assignedTo?: string;
  dueAt?: string;
  checklist?: string[];
}, { success: true; taskId: string }>(functions, "createOperationalTask");

export const resolveWorkItemCallable = httpsCallable<{
  queueItemId: string;
  resolution?: string;
}, { success: true; queueItemId: string; status: string }>(functions, "resolveWorkItem");

export const recomputeMatterReadinessCallable = httpsCallable<{
  clientId: string;
  matterId: string;
  gateId?: string;
}, { success: true; gateId: string; status: string; unmetCount: number }>(functions, "recomputeMatterReadiness");

export const requestExportCallable = httpsCallable<{
  exportType: "SUMMARY" | "DOSSIER" | "MATTER_REPORT" | "EVIDENCE_BUNDLE" | "AUTHORITY_PACK";
  clientId?: string;
  matterId?: string;
  scope?: string;
}, { success: true; exportId: string; status: string }>(functions, "requestExport");

export const buildExportBundleCallable = httpsCallable<{
  exportId: string;
}, { success: true; exportId: string; status: string }>(functions, "buildExportBundle");

export const revokeExportCallable = httpsCallable<{
  exportId: string;
}, { success: true; exportId: string; status: string }>(functions, "revokeExport");

export const classifyAIAnswerCallable = httpsCallable<{
  answer: string;
}, { success: true; answerClass: string; confidenceBand: string; flags: string[] }>(functions, "classifyAIAnswer");

export const proposeActionsFromAnswerCallable = httpsCallable<{
  answer: string;
}, { success: true; actions: string[] }>(functions, "proposeActionsFromAnswer");

export const acceptAIProposedActionCallable = httpsCallable<{
  action: string;
  title?: string;
  clientId?: string;
  matterId?: string;
  runId?: string;
  taskDocId?: string;
}, { success: true; action: string; queueItemId: string; taskId: string | null }>(functions, "acceptAIProposedAction");

export const generateObligationsRegisterCallable = httpsCallable<{
  clientId: string;
  matterId: string;
  title?: string;
  dueAt?: string;
}, { success: true; obligationId: string }>(functions, "generateObligationsRegister");

export const runAgentTaskCallable = httpsCallable<{
  prompt: string;
  taskId?: string;
  taskLabel?: string;
  subject?: string;
  matterId?: string;
  params?: Record<string, unknown>;
}, { success: true; taskDocId: string; status: string }>(functions, "runAgentTask");

export const matchIntentCallable = httpsCallable<{
  prompt: string;
}, { success: true; intent: string; confidence: number }>(functions, "matchIntent");

export const generateAgentReportCallable = httpsCallable<{
  title: string;
  runId?: string;
  taskDocId?: string;
  matterId?: string;
}, { success: true; reportId: string; status: string }>(functions, "generateAgentReport");